const getStatus = (state, actionType) =>
  state[actionType] || {
    isRequested: false,
    isLoading: false,
    error: null,
    success: false
  };

export const getLoginStatus = state => getStatus(state.apiStatus, 'LOGIN');

export const getForgotPasswordStatus = state =>
  getStatus(state.apiStatus, 'FORGOT_PASSWORD');

export const getResetPasswordStatus = state =>
  getStatus(state.apiStatus, 'RESET_PASSWORD');

export const getFetchNextBookingStatus = state =>
  getStatus(state.apiStatus, 'FETCH_NEXT_BOOKING');

export const getFetchCustomerCreditStatus = state =>
  getStatus(state.apiStatus, 'FETCH_CUSTOMER_CREDIT');



// WEBPACK FOOTER //
// ./src/store/apiStatus/selectors.js